import { Button } from "@mui/material";

export const getHeaderConfig = (editVendor, setDeleteDetails) => {
  const headers = [
    {
      label: "Title",
      id: "title"
    },
    {
      label: "Field Type",
      id: "fieldType"
    },
    {
      label: "Actions",
      id: "actions",
      render: (data) => {
        return (
          <>
            <Button
              variant='text'
              // disabled={!isUpdateAllowed("master_data")}
              onClick={() => editVendor(data, "EDIT")}
            >
              Edit
            </Button>
            <Button
              variant='text'
              // disabled={!isDeleteAllowed("master_data")}
              onClick={() => setDeleteDetails(data)}
            >
              Delete
            </Button>
          </>
        );
      }
    }
  ];
  return headers;
};

export const FIELD_TYPES = [
  { label: "Actionable", value: "Actionable" },
  { label: "Document Type", value: "Document Type" },
  { label: "Type Of Vendor", value: "Type Of Vendor" },
  { label: "Upload agreement", value: "Upload agreement" }
];

export const FIELD_TYPES_MAP = {
  actionable: "Actionable",
  documentType: "Document Type",
  typeOfVendor: "Type Of Vendor",
  uploadAgreement: "Upload agreement"
};
